import { cn } from "@/lib/utils";
import { BaseIconProps } from "../Icon.model";

export default function InstagramIcon({
  size = 24,
  fill,
  stroke,
  className,
  ...props
}: BaseIconProps) {
  return (
    <div className="group relative inline-block">
      {/* Default state - visible by default, hidden on hover/focus */}
      <svg
        width={size}
        height={size}
        viewBox="0 0 49 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn(
          "transition-opacity duration-200 group-hover:opacity-0 group-focus:opacity-0",
          className,
        )}
        {...props}
      >
        <g clipPath="url(#clip0_14638_65)">
          <circle
            cx="26.2083"
            cy="23.1797"
            r="21.1484"
            stroke={stroke || "white"}
            strokeWidth="2"
            fill={fill || "none"}
          />
          <path
            d="M30.8728 18.8002H30.8808M22.4728 15.2002H30.4728C32.6819 15.2002 34.4728 16.9911 34.4728 19.2002V27.2002C34.4728 29.4093 32.6819 31.2002 30.4728 31.2002H22.4728C20.2637 31.2002 18.4728 29.4093 18.4728 27.2002V19.2002C18.4728 16.9911 20.2637 15.2002 22.4728 15.2002ZM29.6728 22.6962C29.7715 23.362 29.6578 24.042 29.3478 24.6394C29.0378 25.2368 28.5473 25.7213 27.9461 26.0239C27.3449 26.3265 26.6636 26.4319 25.999 26.3249C25.3345 26.218 24.7206 25.9043 24.2447 25.4283C23.7687 24.9524 23.455 24.3385 23.3481 23.674C23.2411 23.0094 23.3465 22.3281 23.6491 21.7269C23.9517 21.1257 24.4362 20.6352 25.0336 20.3252C25.631 20.0152 26.311 19.9015 26.9768 20.0002C27.6559 20.1009 28.2847 20.4174 28.7702 20.9028C29.2556 21.3883 29.5721 22.0171 29.6728 22.6962Z"
            stroke={stroke || "white"}
            strokeWidth="2.10051"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill={fill || "none"}
          />
        </g>
        <defs>
          <clipPath id="clip0_14638_65">
            <rect
              width="48"
              height="48"
              fill="white"
              transform="translate(0.872803)"
            />
          </clipPath>
        </defs>
      </svg>

      {/* Hover state - hidden by default, visible on hover/focus */}
      <svg
        width={size}
        height={size}
        viewBox="0 0 49 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn(
          "absolute top-0 left-0 opacity-0 transition-opacity duration-200 group-hover:opacity-100 group-focus:opacity-100",
          className,
        )}
        {...props}
      >
        <g clipPath="url(#clip0_14638_65_hover)">
          <circle
            cx="26.2083"
            cy="23.1797"
            r="21.1484"
            stroke="white"
            strokeWidth="2"
            fill="white"
          />
          <path
            d="M30.8728 18.8002H30.8808M22.4728 15.2002H30.4728C32.6819 15.2002 34.4728 16.9911 34.4728 19.2002V27.2002C34.4728 29.4093 32.6819 31.2002 30.4728 31.2002H22.4728C20.2637 31.2002 18.4728 29.4093 18.4728 27.2002V19.2002C18.4728 16.9911 20.2637 15.2002 22.4728 15.2002ZM29.6728 22.6962C29.7715 23.362 29.6578 24.042 29.3478 24.6394C29.0378 25.2368 28.5473 25.7213 27.9461 26.0239C27.3449 26.3265 26.6636 26.4319 25.999 26.3249C25.3345 26.218 24.7206 25.9043 24.2447 25.4283C23.7687 24.9524 23.455 24.3385 23.3481 23.674C23.2411 23.0094 23.3465 22.3281 23.6491 21.7269C23.9517 21.1257 24.4362 20.6352 25.0336 20.3252C25.631 20.0152 26.311 19.9015 26.9768 20.0002C27.6559 20.1009 28.2847 20.4174 28.7702 20.9028C29.2556 21.3883 29.5721 22.0171 29.6728 22.6962Z"
            stroke="black"
            strokeWidth="2.10051"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
        </g>
        <defs>
          <clipPath id="clip0_14638_65_hover">
            <rect
              width="48"
              height="48"
              fill="white"
              transform="translate(0.872803)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}
